import animateScrollTo from 'animated-scroll-to';

import { HOST } from 'constants/global';

export const nextStepUrl = (publicOrderId: string) =>
  HOST + Routes.order_transaction_path(publicOrderId);

export const srollToNewCard = () => {
  const element = document.getElementById('add-new-payment-method');
  if (element) {
    animateScrollTo(element.getBoundingClientRect().y);
  }
};
